import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import colors from "../../assets/theme/colors";
import HandbookSourceListViewer from "./HandbookSourceListViewer";

const ProfileSourceLine = ({
  presentation,
  records = [],
  onAction,
  onVisibilityAction,
  onMarkOutdated,
}) => {
  const [sourceOpen, setSourceOpen] = useState(false);
  if (!presentation?.originLabel) return null;

  const handleAction = (event) => {
    event.stopPropagation();
    if (onAction) {
      onAction(event);
      return;
    }
    if (records.length) setSourceOpen(true);
  };
  const canOpenSource = Boolean(
    presentation.actionLabel && (onAction || records.length),
  );

  return (
    <>
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="baseline"
        flexWrap="wrap"
        sx={{ mt: 0.65 }}
      >
        <Typography
          sx={{
            color: colors.semantic.ink2,
            fontSize: "0.78rem",
            lineHeight: 1.4,
          }}
        >
          {[presentation.originLabel, presentation.dateLabel]
            .filter(Boolean)
            .join(" · ")}
        </Typography>
        {presentation.sourceId ? (
          <Button
            component="a"
            href={`/sources/${presentation.sourceId}`}
            size="small"
            sx={{ p: 0, textTransform: "none" }}
          >
            Open source note
          </Button>
        ) : null}
        {canOpenSource ? (
          <Box
            component="span"
            role="button"
            tabIndex={0}
            onClick={handleAction}
            onKeyDown={(event) => {
              if (event.key !== "Enter" && event.key !== " ") return;
              event.preventDefault();
              handleAction(event);
            }}
            sx={{
              color: colors.semantic.sageDeep,
              fontSize: "0.78rem",
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
              "&:focus-visible": {
                outline: `2px solid ${colors.semantic.sageDeep}`,
                outlineOffset: 2,
              },
            }}
          >
            {presentation.actionLabel}
          </Box>
        ) : null}
        {onVisibilityAction ? (
          <Box
            component="span"
            role="button"
            tabIndex={0}
            onClick={(event) => {
              event.stopPropagation();
              onVisibilityAction();
            }}
            onKeyDown={(event) => {
              if (event.key !== "Enter" && event.key !== " ") return;
              event.preventDefault();
              event.stopPropagation();
              onVisibilityAction();
            }}
            sx={{
              color: colors.semantic.ink2,
              fontSize: "0.76rem",
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
              "&:focus-visible": {
                outline: `2px solid ${colors.semantic.sageDeep}`,
                outlineOffset: 2,
              },
            }}
          >
            Hide from Profile
          </Box>
        ) : null}
        {onMarkOutdated ? (
          <Box
            component="span"
            role="button"
            tabIndex={0}
            onClick={(event) => {
              event.stopPropagation();
              onMarkOutdated();
            }}
            onKeyDown={(event) => {
              if (event.key !== "Enter" && event.key !== " ") return;
              event.preventDefault();
              event.stopPropagation();
              onMarkOutdated();
            }}
            sx={{
              color: colors.semantic.ink2,
              fontSize: "0.76rem",
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
              "&:focus-visible": {
                outline: `2px solid ${colors.semantic.sageDeep}`,
                outlineOffset: 2,
              },
            }}
          >
            No longer current
          </Box>
        ) : null}
      </Stack>
      {presentation.approvalLabel?<Typography sx={{fontSize:"0.78rem",color:"text.secondary"}}>{presentation.approvalLabel}</Typography>:null}
      <HandbookSourceListViewer
        open={sourceOpen}
        records={records}
        onClose={() => setSourceOpen(false)}
      />
    </>
  );
};

export default ProfileSourceLine;
